module.exports = __webpack_public_path__ + "media/icons/scroll@2x-a893a291.png";